module.exports = __webpack_public_path__ + "static/media/Cipher.ecd0fe37.png";